export const getActiveFilters = (
  preselectedFilters: string[] = [],
  userSelectedFilters: string[] = [],
): string[] => {
  return [...new Set(preselectedFilters.concat(userSelectedFilters))];
};
